export default __webpack_public_path__ + "static/media/truck.6d0aeb2d.svg";